import React, { useEffect, useState } from "react";
import Select from "react-select";

export type Option = {
  value: string;
  label: string;
};

export interface SelectProps {
  options: Option[];
  defaultValue?: Option;
  className?: string;
  styles?: any;
  onChange?: (option: Option | null) => void;
  value?: Option | null;
  isRequired?: boolean;
}

const CommonSelect: React.FC<SelectProps> = ({
  options,
  defaultValue,
  className,
  styles,
  onChange,
  value,
  isRequired,
}) => {
  const [selectedOption, setSelectedOption] = useState<Option | undefined>(
    defaultValue
  );

  const handleChange = (option: Option | null) => {
    setSelectedOption(option || undefined);
    if (onChange) {
      onChange(option);
    }
  };

  // const handleChange = (option: Option | null) => {
  //   setSelectedOption(option || undefined);
  // };
  useEffect(() => {
    setSelectedOption(defaultValue || undefined);
  }, [defaultValue, options]);

  const customStyles = {
    option: (base: any, state: any) => ({
      ...base,
      color: "#6A7287 !important",
      backgroundColor: state.isSelected
        ? "#ddd !important"
        : "white !important",
      cursor: "pointer",
      "&:hover": {
        backgroundColor: state.isFocused
          ? "#3D5EE1 !important"
          : "blue !important",
        color: state.isFocused ? "#fff !important" : "#6A7287 !important",
      },
    }),
  };

  return (
    <Select
      classNamePrefix="react-select"
      className={className}
      options={options}
      value={value}
      onChange={handleChange}
      placeholder="Select"
      isClearable
      required={isRequired}
      styles={customStyles}
    />
  );
};

export default CommonSelect;
